import { useState } from 'react';
import { Link } from 'react-router-dom';
import { tools } from '../toolData';

export default function Home() {
  const [search, setSearch] = useState('');

  const filteredTools = tools.filter(tool => {
    if (!tool || typeof tool !== 'object') return false;

    const name = (tool.name || '').toLowerCase();
    const description = (tool.description || '').toLowerCase();
    const category = (tool.category || '').toLowerCase();
    const query = search.toLowerCase();

    return (
      name.includes(query) ||
      description.includes(query) ||
      category.includes(query)
    );
  });

  return (
    <div className="max-w-4xl mx-auto px-4 py-0 text-white">
      {/* Title and Description */}
      <header className="mb-10 text-center">
        <h1 className="text-3xl font-bold text-blue-200">Electrical Engineering Tools</h1>
        <p className="text-gray-400 mt-2">Handy calculators and converters for EE students and professionals :)</p>
      </header>

      {/* Search Bar */}
      <div className="mb-12 text-center">
        <input
          type="text"
          placeholder="Search Tools..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full sm:w-2/3 px-4 py-2 rounded bg-gray-800 text-white placeholder-gray-400 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      {/* Tool Links */}
      <main className="grid gap-6 sm:grid-cols-2 mb-16">
        {filteredTools.map((tool) => (
          <Link
            key={tool.id}
            to={`/${tool.id}`}
            className="block bg-gray-800 p-4 rounded shadow hover:bg-gray-700 transition text-blue-200 text-lg font-medium text-center"
          >
            {tool.name}
          </Link>
        ))}
      </main>

      {/* Footer Links */}
      <footer className="border-t border-gray-700 pt-6 mt-12 text-center text-sm text-gray-400">
        <p className="mb-2">© {new Date().getFullYear()} Electrical Engineering Tools</p>
        <div className="flex justify-center space-x-4">
          <Link to="/about" className="hover:underline">About</Link>
          <Link to="/contact" className="hover:underline">Contact</Link>
          <Link to="/privacy-policy" className="hover:underline">Privacy Policy</Link>
        </div>
      </footer>
    </div>
  );
}
